import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';   
import { EventService } from '../../services/event.service';

@Component({
  selector: 'consolidation-confirm',
  templateUrl: './consolidation-confirm.component.html',
  styleUrls: ['./consolidation-confirm.component.scss']
})
export class ConsolidationConfirmComponent implements OnInit {

  constructor(
    private eventService: EventService,
    public activeModal: NgbActiveModal
  ) { }
  public modalMessage: string = ''; 
  public isActivatingDatasets: boolean = false;

  ngOnInit() { 

  }

  showModal(message: string) { 
    this.modalMessage = message; 
  } 

  continueConsolidation() { 
    //Return the result of the modal
    this.eventService.sendConsolidationConfirmEvent();

    this.activeModal.dismiss(false); 
  }
}
